import React, { Children, isValidElement, ReactElement } from 'react'
import { TabPanel, TabPanelProps, TabViewProps, TabViewTabChangeEvent } from 'primereact/tabview'
import { useSearchParams } from 'react-router-dom'

import { LazyTabView } from '../../uikit/LazyTabView'

const ACTIVE_TAB_SEARCH_PARAM = 'tab'

export function OcppChargePointTabView({ children, onTabChange, ...props }: TabViewProps): React.ReactElement {
    const [searchParams, setSearchParams] = useSearchParams()
    const tabs: ReactElement<TabPanelProps>[] = []

    Children.forEach(children, (child) => {
        if (isValidElement<TabPanelProps>(child) && child.type === TabPanel) {
            tabs.push(child)
        }
    })
    const activeTab = searchParams.get(ACTIVE_TAB_SEARCH_PARAM)
    const activeIndex = Math.max(
        0,
        tabs.findIndex((tab) => tab.key === activeTab)
    )

    const handleTabChange = (event: TabViewTabChangeEvent) => {
        const nextSearchParams = new URLSearchParams(searchParams)
        nextSearchParams.set(ACTIVE_TAB_SEARCH_PARAM, String(tabs[event.index].key))
        setSearchParams(nextSearchParams, { replace: true })
        onTabChange?.(event)
    }

    return (
        <LazyTabView {...props} activeIndex={activeIndex} onTabChange={handleTabChange}>
            {children}
        </LazyTabView>
    )
}
